import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1054"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.586 12.321c.091.016 1.427.24 2.99.24 1.019 0 2.134-.095 3.062-.405 3.753-1.253 6.211.066 6.312.123a.7.7 0 1 0 .689-1.219c-.123-.069-3.069-1.692-7.444-.232-.31.104-.653.176-1.007.228l5.776-6.136a.361.361 0 0 0-.263-.609H9.318a.118.118 0 0 1-.099-.182l2.264-2.745a.253.253 0 0 0-.212-.39H7.158a.434.434 0 0 0-.378.222L3.735 5.951a.362.362 0 0 0 .316.537h2.435c.079 0 .135.076.113.151l-1.311 4.505c-1.718.09-3.442-.198-3.466-.202a.71.71 0 0 0-.808.572.7.7 0 0 0 .572.807zm13.054 1.182c-.123-.069-3.069-1.692-7.444-.232-2.02.676-5.34.119-5.373.113a.708.708 0 0 0-.808.572.7.7 0 0 0 .571.808c.091.016 1.427.24 2.99.24 1.019 0 2.134-.095 3.062-.405 3.753-1.253 6.211.067 6.312.123a.698.698 0 0 0 .954-.265.699.699 0 0 0-.264-.954z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }